<template>
  <div class="settings-page">
    <settings-list />
  </div>
</template>

<script>

import SettingsList from "@/pages/Utils/SettingsList.vue";

export default {
  name: 'SettingsPage',
  components: {
    SettingsList
  }
};
</script>

<style scoped>
.settings-page {
  padding: 20px;
  background: #f9f9f9;
  min-height: 100vh;
}
</style>